import React from 'react';
import Sym from '../components/Sym';
import SectionHead from '../components/SectionHead';

/**
 * Comparativo «PaySlip sí / PaySlip no» — clave para dejar claro el alcance del
 * producto (no calcula, no timbra, no dispersa). Copy literal del diseño; es
 * exactamente lo que separa a PaySlip de un sistema de nómina.
 */
const SI = [
  'Descarga tus recibos del SAT con tu e.firma',
  'Los entrega a administradores y colaboradores',
  'Ofrece un portal 24/7 para consultarlos',
  'Guarda el histórico completo, con respaldo',
];
const NO = [
  'No calcula tu nómina',
  'No timbra los CFDI (eso ya lo hiciste ante el SAT)',
  'No dispersa pagos',
  'No sustituye a tu contador ni a tu sistema de nómina',
];

const Row = ({ icon, color, text, textColor }) => (
  <div style={{ display: 'flex', gap: 11, alignItems: 'flex-start' }}>
    <Sym name={icon} size={22} color={color} />
    <span style={{ font: "500 1.02rem/1.4 'Hanken Grotesk'", color: textColor }}>{text}</span>
  </div>
);

const Comparison2 = () => (
  <section style={{ maxWidth: 1100, margin: '0 auto', padding: '0 clamp(20px,5vw,40px) clamp(48px,7vw,88px)' }}>
    <SectionHead eyebrow="Claridad total" title="Lo que PaySlip hace," accent="y lo que no" />
    <div className="ls2-grid2" style={{ marginTop: 36 }}>
      {/* PaySlip sí */}
      <div style={{ background: 'var(--surface)', border: '1px solid rgba(47,107,255,.28)', borderRadius: 22, padding: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
          <span style={{ width: 38, height: 38, borderRadius: 11, background: 'rgba(47,107,255,.16)', display: 'grid', placeItems: 'center' }}>
            <Sym name="check" size={22} color="#6FA0FF" />
          </span>
          <h3 style={{ font: "700 1.2rem 'Source Serif 4'", color: 'var(--heading)', margin: 0 }}>PaySlip sí</h3>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {SI.map((t) => <Row key={t} icon="check_circle" color="#6FA0FF" text={t} textColor="var(--body-strong)" />)}
        </div>
      </div>
      {/* PaySlip no (siempre oscuro) */}
      <div data-dark style={{ background: '#0B1220', border: '1px solid rgba(255,255,255,.07)', borderRadius: 22, padding: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
          <span style={{ width: 38, height: 38, borderRadius: 11, background: 'rgba(255,255,255,.05)', display: 'grid', placeItems: 'center' }}>
            <Sym name="do_not_disturb_on" size={22} color="#6C7A96" />
          </span>
          <h3 style={{ font: "700 1.2rem 'Source Serif 4'", color: '#B7C2D8', margin: 0 }}>PaySlip no</h3>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {NO.map((t) => <Row key={t} icon="remove" color="#6C7A96" text={t} textColor="#8A97B2" />)}
        </div>
      </div>
    </div>
  </section>
);

export default Comparison2;
